import { Reveal } from "@/components/Reveal";
import { SectionHead } from "@/components/SectionHead";
import { Crosshair, Layers, Target, BarChart3, FileBarChart, ShieldCheck } from "lucide-react";

const CARDS = [
  { icon: Crosshair, title: "SEO-First Approach", text: "SEO is not one of twenty services here. It is the service. Every process, tool and report is built around organic search." },
  { icon: Layers, title: "Technical + Content", text: "Rankings need both a healthy website and content worth ranking. We work the infrastructure and the substance together." },
  { icon: Target, title: "Search-Intent Driven", text: "Every page is mapped to what the searcher actually wants — informational, commercial or transactional — before a word is written." },
  { icon: BarChart3, title: "Data-Driven Decisions", text: "Search Console, analytics and crawl data guide priorities. Opinions are tested; data decides what ships first." },
  { icon: FileBarChart, title: "Transparent Reporting", text: "Monthly reports show work completed, movement measured and the next plan. You always know what your money did." },
  { icon: ShieldCheck, title: "No Black-Hat Shortcuts", text: "No link farms, no keyword stuffing, no guaranteed-#1 promises. Ethical SEO that survives algorithm updates." },
];

export function WhyUs() {
  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-rw-bg2 border-y border-rw-border" data-testid="why-section">
      <div className="container-rw">
        <SectionHead
          eyebrow="Why Ravi Works"
          title="A specialist, not a supermarket."
          description="Six principles that shape every engagement. What you will never hear from us: guaranteed rankings, instant results or secret methods."
          testid="why-head"
        />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div
                className="group relative h-full rounded-2xl border border-rw-border bg-rw-card p-7 transition-all duration-300 hover:border-rw-green/50 hover:bg-rw-cardh hover:-translate-y-1"
                data-testid={`why-card-${i + 1}`}
              >
                <span className="font-mono text-sm text-rw-green">0{i + 1}</span>
                <c.icon className="mt-5 text-rw-green transition-transform duration-300 group-hover:scale-110" size={28} />
                <h3 className="mt-4 font-jakarta text-lg font-bold text-rw-text uppercase tracking-wide">{c.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-rw-muted">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
